var spoiler_default = {
  "fontElementMap": "XR5G-",
  "hideText": "ERfFz",
  "onHoverText": "urYzf",
  "hideBlock": "rQcp9",
  "smallBlur": "INNIc",
  "mediumBlur": "XhOtl",
  "largeBlur": "_35XBQ",
  "hideBlock_gallery": "_6FiQt",
  "overlay": "ze9mA",
  "overlay_gallery": "YiI9A",
  "revealSpoilerBtn": "Y-HyB",
  "isMobile": "_8IE4t",
  "onHoverBtn": "R3dOC",
  "spoilerWrapper": "hkVRb",
  "spoilerDescription": "-LY8d",
  "spoilerContainer": "pj8JM",
  "spoilerContainer_Gallery": "S68wI"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
